import React, { useState } from "react";
import PBaseDialog from "../../../ui/dialogs/PBaseDialog";
import SelectAttendeesScreen from "./SelectAttendeesScreen";
import ComposeMessageScreen from "./ComposeMessageScreen";
import ReviewScreen from "./ReviewScreen";
import { components } from "../../../../api/spec";

type EventAttendeeSummarySchema =
  components["schemas"]["EventAttendeeSummarySchema"];

interface SelectAttendeesDialogProps {
  attendees: EventAttendeeSummarySchema[] | null;
  onConfirm: (result: { memberIds: string[]; message: string }) => void;
  onCancel: () => void;
}

type DialogStep = "select" | "compose" | "review";

const SelectAttendeesDialog: React.FC<SelectAttendeesDialogProps> = ({
  attendees,
  onConfirm: onConfirmInput,
  onCancel,
}) => {
  const [currentStep, setCurrentStep] = useState<DialogStep>("select");
  const [selectedAttendees, setSelectedAttendees] = useState<
    EventAttendeeSummarySchema[]
  >([]);
  const [message, setMessage] = useState("");

  const handleSelectNext = (selected: EventAttendeeSummarySchema[]) => {
    setSelectedAttendees(selected);
    setCurrentStep("compose");
  };

  const handleComposeNext = (messageText: string) => {
    setMessage(messageText);
    setCurrentStep("review");
  };

  const handleComposeBack = () => {
    setCurrentStep("select");
  };

  const handleReviewBack = () => {
    setCurrentStep("compose");
  };

  const onConfirm = () => {
    const memberIds = selectedAttendees.map((attendee) => attendee.guid!);
    onConfirmInput({ memberIds, message });
  };

  return (
    <PBaseDialog show onClose={onCancel} includePadding={false}>
      <div className="sm:max-h-[90vh]">
        {attendees === null ? (
          <div className="flex items-center justify-center py-12 bg-black text-white">
            Loading attendees...
          </div>
        ) : (
          <>
            {currentStep === "select" && (
              <SelectAttendeesScreen
                attendees={attendees}
                onNext={handleSelectNext}
                selectedAttendees={selectedAttendees}
              />
            )}
            {currentStep === "compose" && (
              <ComposeMessageScreen
                recipientCount={selectedAttendees.length}
                onNext={handleComposeNext}
                onBack={handleComposeBack}
              />
            )}
            {currentStep === "review" && (
              <ReviewScreen
                selectedAttendees={selectedAttendees}
                message={message}
                onConfirm={() => onConfirm()}
                onBack={handleReviewBack}
              />
            )}
          </>
        )}
      </div>
    </PBaseDialog>
  );
};

export default SelectAttendeesDialog;
